var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { dark: "" } },
    [
      this.hasToken && _vm.renderLayout ? _c("core-app-bar") : _vm._e(),
      _vm._v(" "),
      this.hasToken && _vm.renderLayout ? _c("core-drawer") : _vm._e(),
      _vm._v(" "),
      _c("core-view"),
      _vm._v(" "),
      _vm.renderLayout ? _c("snackbar") : _vm._e(),
      _vm._v(" "),
      _vm.renderLayout ? _c("ConsentDialog") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }